import React from "react";
import { motion } from "framer-motion";
import "./App.css";

const scrollToSection = (id) => {
  document.getElementById(id).scrollIntoView({ behavior: "smooth" });
};

function Navbar() {
  return (
    <div className="navbar">
      <div className="brand-container">
        <div className="logo">SE</div>
        <h3 className="brand">Star Enterprises Solutions</h3>
      </div>

      <div className="nav-links">
        <span onClick={() => scrollToSection("home")}>Home</span>
        <span onClick={() => scrollToSection("services")}>Services</span>
        <span onClick={() => scrollToSection("about")}>About</span>
        <span onClick={() => scrollToSection("contact")}>Contact</span>
      </div>
    </div>
  );
}

function Section({ id, children, className }) {
  return (
    <section id={id} className={`section ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
        className="content"
      >
        {children}
      </motion.div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <h3>Star Enterprises Solutions</h3>

      <p>
        We build modern websites, mobile apps, and digital solutions for
        businesses.
      </p>

      <p className="copyright">
        © 2018 - {new Date().getFullYear()} Star Enterprises Solutions. All
        rights reserved.
      </p>
    </footer>
  );
}
function App() {
  const [scroll, setScroll] = React.useState(0);

  React.useEffect(() => {
    const handleScroll = () => {
      const total = document.documentElement.scrollHeight - window.innerHeight;

      const progress = (window.scrollY / total) * 100;
      setScroll(progress);
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      {/* 🔥 Scroll Progress Bar */}
      <div className="progress" style={{ width: `${scroll}%` }} />

      <Navbar />

      {/* HERO */}
      <Section id="home" className="hero">
        <h1>We Build High-Performance Digital Products</h1>
        <p>Websites • Apps • UI/UX • Scalable Systems</p>
        <p>
          Star Enterprises Solutions is a modern web development company helping
          startups and businesses build fast, scalable and conversion-focused
          digital products.
        </p>
        <button className="btn">
          Modern, fast, and SEO-ready websites for growing businesses
        </button>
      </Section>

      {/* SERVICES */}
      <Section id="services" className="services">
        <h2>Our Services</h2>

        <p>
          We provide complete digital solutions to help your business grow
          online.
        </p>

        <div className="grid">
          <div className="card">
            ⚡ Web Development
            <p>
              Modern, fast, and responsive websites built using latest
              technologies like React, Next.js, and Node.js.
            </p>
          </div>

          <div className="card">
            📱 App Development
            <p>
              High-performance Android & iOS applications with smooth UI and
              scalable backend systems.
            </p>
          </div>

          <div className="card">
            🎨 UI/UX Design
            <p>
              Clean, modern and user-friendly designs that improve user
              experience and increase conversions.
            </p>
          </div>
        </div>
      </Section>

      <Section id="why" className="services">
        <h2>Why Choose Star Enterprises?</h2>

        <div className="grid">
          <div className="card">🚀 Fast Delivery </div>
          <div className="card">💰 Affordable Pricing</div>
          <div className="card">📈 SEO Optimized Websites</div>
          <div className="card">🔒 Secure & Scalable Code</div>
          <div className="card">📱 Mobile Friendly Design</div>
          <div className="card">🤝 24/7 Support</div>
        </div>
      </Section>

      {/* ABOUT  page*/}

      <Section id="about" className="about">
        <div className="about-container">
          {/* LEFT SIDE TEXT */}
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h2>About Star Enterprises Solutions</h2>

            <p>
              Star Enterprises Solutions is a forward-thinking digital agency
              dedicated to building high-performance websites, mobile
              applications, and scalable software solutions.
            </p>

            <p>
              Since 2018, we have helped startups and businesses grow with
              modern, fast, and user-friendly digital products.
            </p>

            <p>
              Our focus is on clean code, modern UI/UX design, and scalable
              systems that help businesses succeed online.
            </p>

            <div className="about-stats">
              <div>✔ 8+ Years Experience</div>
              <div>✔ 1200+ Projects</div>
              <div>✔ 100% Client Satisfaction</div>
            </div>
          </motion.div>

          {/* RIGHT SIDE IMAGE */}
          <motion.div
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
          >
            <img
              src="https://images.unsplash.com/photo-1551434678-e076c223a692"
              alt="team"
            />
          </motion.div>
        </div>
      </Section>

      {/* Contact page */}
      <Section id="contact" className="contact">
        <div className="contact-content">
          <h2>Let’s Connect</h2>

          <p>
            Whether you want to build a project, apply for a job, or get
            information about our services — we’re here to help.
          </p>

          {/* CONTACT OPTIONS */}

          <div className="grid">
            {/* PROJECT DISCUSSION */}
            <div className="card">
              <h3>💼 Project Discussion</h3>
              <p>Want to build a website, app, or software? Let’s talk.</p>
              <p>
                <b>ITServices@StarEnterprisesSolutions.com</b>
              </p>
            </div>

            {/* CAREERS */}
            <div className="card">
              <h3>🚀 Careers / Jobs</h3>
              <p>Apply for internship or job opportunities in our company.</p>
              <p>
                <b>Apply@StarEnterprisesSolutions.com</b>
              </p>
            </div>

            {/* HR */}
            <div className="card">
              <h3>👨‍💼 HR Department</h3>
              <p>For employee-related queries and HR support.</p>
              <p>
                <b>HR@StarEnterprisesSolutions.com</b>
              </p>
            </div>
          </div>
        </div>
      </Section>
      <Footer />
    </div>
  );
}

export default App;
